import { TOOL_REGISTRY } from "@/lib";

/**
 * Formats an array of tool names into the proper tool object format
 * expected by the OpenAI API for assistant configuration.
 *
 * @param {string[]} toolNames - Array of tool names to format
 * @returns {Object[]} Array of formatted tool objects
 */
export const formatToolsForAssistant = (toolNames) => {
  if (!Array.isArray(toolNames)) return [];

  return toolNames
    .map((toolName) => {
      // Skip any invalid tools
      if (!TOOL_REGISTRY[toolName]) {
        console.warn(`Tool not found in registry: ${toolName}`);
        return null;
      }

      // Special case for built-in tools
      if (toolName === "code_interpreter") {
        return { type: "code_interpreter" };
      }

      if (toolName === "file_search") {
        return { type: "file_search" };
      }

      // Get the tool registry entry
      const toolDef = TOOL_REGISTRY[toolName];

      // Skip tools without proper definition
      if (!toolDef) {
        console.warn(`No tool definition found for: ${toolName}`);
        return null;
      }

      // Determine parameters with fallback options
      const parameters =
        // First try the standard tool.function.parameters path
        toolDef.function?.parameters ||
        // Then try the definition path which some tools use
        toolDef.definition?.function?.parameters ||
        // Then try accessing parameters through tool.parameters (if structured differently)
        toolDef.parameters || {
          // Finally fallback to empty parameters structure if all else fails
          type: "object",
          properties: {},
          required: [],
        };

      // Create tool object in the format expected by OpenAI
      return {
        type: "function",
        function: {
          name: toolName,
          description: toolDef.description || `Function: ${toolName}`,
          parameters: parameters,
        },
      };
    })
    .filter(Boolean); // Remove any null entries
};
